import React from 'react';
import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';

import {
  AppliedFeedReference,
  REFERENCED_NUTRIENTS,
} from '../../../../services/feedAnalysisService';
import { formatNumber, formatTolerance, monthShort } from '../format';

interface AppliedReferencesTableProps {
  references: AppliedFeedReference[];
}

// bloco "valores de referência aplicados neste mês" da planilha
export const AppliedReferencesTable: React.FC<AppliedReferencesTableProps> = ({
  references,
}) => (
  <Box
    bg="gray.800"
    borderWidth="1px"
    borderColor="gray.700"
    borderRadius="lg"
    overflowX="auto"
  >
    <Table size="sm">
      <Thead>
        <Tr>
          <Th rowSpan={2} minW="200px">
            Ração
          </Th>
          <Th rowSpan={2}>Fórmula</Th>
          <Th rowSpan={2}>Vigência</Th>
          <Th rowSpan={2}>Tolerância</Th>
          {REFERENCED_NUTRIENTS.map(nutrient => (
            <Th
              key={nutrient.key}
              colSpan={3}
              textAlign="center"
              borderLeftWidth="1px"
              borderColor="gray.700"
            >
              {nutrient.label}
            </Th>
          ))}
        </Tr>
        <Tr>
          {REFERENCED_NUTRIENTS.map(nutrient => (
            <React.Fragment key={nutrient.key}>
              <Th isNumeric borderLeftWidth="1px" borderColor="gray.700">
                Mín.
              </Th>
              <Th isNumeric color="blue.300">
                Esper.
              </Th>
              <Th isNumeric>Máx.</Th>
            </React.Fragment>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {references.map(row => (
          <Tr key={row.feed_id}>
            <Td fontWeight="600">{row.feed_name}</Td>
            <Td whiteSpace="nowrap">
              {row.formula_code || (
                <Text as="span" color="yellow.300">
                  Sem fórmula
                </Text>
              )}
            </Td>
            <Td>
              {row.reference ? monthShort(row.reference.valid_from) : '—'}
            </Td>
            <Td whiteSpace="nowrap">
              {row.reference
                ? formatTolerance(
                    row.reference.tolerance_below,
                    row.reference.tolerance_above,
                  )
                : '—'}
            </Td>
            {REFERENCED_NUTRIENTS.map(nutrient => {
              const range = row.nutrients[nutrient.key];
              return (
                <React.Fragment key={nutrient.key}>
                  <Td isNumeric borderLeftWidth="1px" borderColor="gray.700">
                    {formatNumber(range.min)}
                  </Td>
                  <Td isNumeric color="blue.300" fontWeight="600">
                    {formatNumber(range.expected)}
                  </Td>
                  <Td isNumeric>{formatNumber(range.max)}</Td>
                </React.Fragment>
              );
            })}
          </Tr>
        ))}
      </Tbody>
    </Table>
  </Box>
);
